import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import { usePaymentTerminals } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/hooks/usePaymentTerminals'
import { usePaymentMethodOptions } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/utils/paymentMethodTranslations'
import { PaymentMethod } from '~/components/dashboard/invoices/payment/constants/addPaymentDialogV2Constants'

import PaymentDropdown from '../../../add-payment-dialog-v2/components/PaymentDropdown'
import { useRefundDialog } from '../context/RefundDialogProvider'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PaymentTerminalSection.module.scss'

export const PaymentTerminalSection = () => {
  const { t } = useTranslation(['Common', 'Dialogs'])
  const { paymentTerminalOptions, loading, refetch } = usePaymentTerminals()
  const { dialogState, actions, isLoading } = useRefundDialog()
  const allPaymentMethods = usePaymentMethodOptions()
  const availablePaymentTerminals =
    paymentTerminalOptions.filter((terminal) => terminal.selectable).length > 0

  // Filter out CARECREDIT option
  const refundPaymentMethods = allPaymentMethods.filter(
    (method) => method.value !== PaymentMethod.CARECREDIT,
  )

  useEffect(() => {
    refetch()
  }, [])

  return (
    <>
      {dialogState.refundMethod === PaymentMethod.CREDIT_DEBIT &&
        !loading &&
        !availablePaymentTerminals && (
          <KibTopLevelAlert
            heading={t('Dialogs:ADD_PAYMENT_DIALOG_V2.NO_TERMINALS_AVAILABLE')}
            severity="error"
          >
            {t('Dialogs:REFUND_DIALOG_V2.PAYMENT_TERMINALS_OFFLINE_HELP_TEXT')}
          </KibTopLevelAlert>
        )}
      <div className={styles.fieldGrid}>
        <div className={styles.fieldColumn}>
          <PaymentDropdown
            disabled={isLoading}
            label={t('Dialogs:REFUND_DIALOG_V2.REFUND_METHOD')}
            options={refundPaymentMethods}
            value={dialogState.refundMethod}
            onChange={(value) => {
              actions.setRefundMethod(value as PaymentMethod)
            }}
          />
        </div>
        {dialogState.refundMethod === PaymentMethod.CREDIT_DEBIT && (
          <div className={styles.fieldColumn}>
            <PaymentDropdown
              required
              disabled={loading || !availablePaymentTerminals || isLoading}
              label={t('Dialogs:ADD_PAYMENT_DIALOG_V2.PAYMENT_TERMINAL')}
              messages={{
                valueMissing: t(
                  'Dialogs:ADD_PAYMENT_DIALOG_V2.VALIDATION.PAYMENT_TERMINAL_REQUIRED',
                ),
              }}
              options={paymentTerminalOptions}
              placeholder={
                loading ? t('Common:LOADING') : t('Common:SELECT_ACTION')
              }
              value={dialogState.selectedPaymentTerminal || ''}
              onChange={(value) => {
                const selectedTerminal = paymentTerminalOptions.find(
                  (terminal) => terminal.value === value,
                )
                actions.setSelectedPaymentTerminal(
                  value,
                  selectedTerminal?.label || '',
                )
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}
